import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

export const Hint = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

export const COLUMN_NAMES = {
  NA: 'Not Applicable',
  REQUIRED: 'Required',
  OPTIONAL: 'Optional',
};

export const ROWSPERPAGE = [10, 15, 25, 50, 100, 500, 1000, 2000];
// export const ERRORS = {
//   TOTAL_QTY: "Total quantity can not be null or 0",
//   QTY: "Available quantity can not be null",
//   QTY_INVALID: "Available quantity can not be more than total quantity",
// };

export const PAGES = {
  INVENTORY: 'Inventory Management',
  EQUIPMENT: 'Equipment',
  LOCATION: 'Locations',
};

export const COLUMNS = {
  ETY_NAME: 'EntityName',
  ETY_TYPE: 'EntityType',
  LEVEL: 'Level',
  ETY_STATUS: 'EntityStatus',
  ETY_COMMENT: 'EntityComment',
  // TOTAL_QTY: "TotalQuantity",
  // QTY: "AvailableQuantity",
  CLONE: 'Clone',
};

export const LABELS = {
  ETY_NAME: 'Name',
  ETY_TYPE: 'Type',
  LEVEL: 'Level',
  ETY_STATUS: 'Status',
  ETY_COMMENT: 'Comments',
  CLONE: 'Clone',
};

export const LINKS = {
  HOME: 0,
  EQUIPMENT: 1,
  LOCATION: 2,
  MATERIAL: 3,
  OPERATIONS: 4,
  ADMIN: 5,
  REPORTS: 6,
  RELEASENOTES: 7,
  KIOSK: 8,
  WORKFLOW: 9,
  CORPSERVICE: 10,
};

export const BINARY_MSG = {
  YES: ' Updated to True',
  NO: ' Updated to False',
};

export const TRANSACTION_STATUS = {
  GIVEIT: { ID: 1, DB_STATUS: 'Give It', DESCRIPTION: 'Give It', EOL: false },
  REQUEST: { ID: 2, DB_STATUS: 'Request', DESCRIPTION: 'Request', EOL: false },
  RECLAIM: { ID: 3, DB_STATUS: 'Reclaim', DESCRIPTION: 'Reclaim', EOL: true },
  SHIP: { ID: 4, DB_STATUS: 'Ship', DESCRIPTION: 'Ship', EOL: true },
  SCRAP: { ID: 5, DB_STATUS: 'Scrap', DESCRIPTION: 'Scrap', EOL: true },
  LOAN: { ID: 6, DB_STATUS: 'Loan', DESCRIPTION: 'Loan', EOL: false },
  OPEN: { ID: 7, DB_STATUS: 'Open', DESCRIPTION: 'Putaway Open', EOL: false },
  GOT: { ID: 8, DB_STATUS: 'Got', DESCRIPTION: 'Got It', EOL: false },
  PKOCONBO: {
    ID: 9,
    DB_STATUS: 'PKOCONBO',
    DESCRIPTION: 'Pickup Completed',
    EOL: false,
  },
  PKOCRE: {
    ID: 10,
    DB_STATUS: 'PKOCRE',
    DESCRIPTION: 'Pickup Created',
    EOL: false,
  },
  PTOCRE: {
    ID: 11,
    DB_STATUS: 'PTOCRE',
    DESCRIPTION: 'Putaway Created',
    EOL: false,
  },
  PKOCNL: {
    ID: 12,
    DB_STATUS: 'PKOCNL',
    DESCRIPTION: 'Pickup Cancelled',
    EOL: false,
  },
  PTOERR: {
    ID: 13,
    DB_STATUS: 'Error(PTO)',
    DESCRIPTION: 'Putaway Error',
    EOL: false,
  },
  PKOERR: {
    ID: 14,
    DB_STATUS: 'PKOERR',
    DESCRIPTION: 'Pickup Error',
    EOL: false,
  },
  SYNCERR: {
    ID: 15,
    DB_STATUS: 'Error(Sync)',
    DESCRIPTION: 'Geek Sync Error',
    EOL: false,
  },
  COMPLETE: {
    ID: 16,
    DB_STATUS: 'Complete',
    DESCRIPTION: 'Complete',
    EOL: true,
  },
  RETURNLOAN: {
    ID: 17,
    DB_STATUS: 'Return Loan',
    DESCRIPTION: 'Return Loan',
    EOL: false,
  },
  DECLINED: {
    ID: 18,
    DB_STATUS: 'Declined',
    DESCRIPTION: 'Declined',
    EOL: true,
  },
  GEEKPICKUP: {
    ID: 19,
    DB_STATUS: 'GeekPickup',
    DESCRIPTION: 'Geek Pick Up',
    EOL: false,
  },
  EXTENDLOAN: {
    ID: 20,
    DB_STATUS: 'Extend Loan',
    DESCRIPTION: 'Extend Loan',
    EOL: false,
  },
};

export const GEEK_TRAS = {
  PTO: 'Putaway ',
  PKO: 'Pickup ',
};

export const STOCK_ADJUST = {
  PENDING: 'Stock Adjust Pending',
  RESOLVED: 'Stock Adjust Resolved',
};

export const environmentLabels = {
  qa: 'QA',
  development: 'DEV',
  local: 'DEV',
};

export const environmentUrls = {
  production: 'https://swt-elm-server-prod.azurewebsites.net',
  qa: 'https://swt-elm-server-qa.azurewebsites.net',
  development: 'https://swt-elm-server.azurewebsites.net',
  local: 'http://localhost:8080',
};

export const ISO_SERVICE_INFORMATION = {
  CALIBRATTION: 'Calibration',
  MAINTENANCE: 'Maintenance',
  INDICATION: 'For Indication Only',
};

export const ISO_SERVICE_FILE_LINKS_TYPE = {
  OUT_OF_TOLERANCE: { ID: 1, LABEL: 'Out Of Tolerance' },
  CHANGE_REQUEST_FORM: { ID: 2, LABEL: 'Change Request Form' },
  SERVICE_RECORD: { ID: 3, LABEL: 'Service Record' },
  SERVICE_CHECKLIST: { ID: 4, LABEL: 'Service Checklist' },
};

// columns to be removed from column manager
export const REMOVE_FROM_SEARCH_COLUMNS = {
  SERVICE_NOTES_COMMENTS: { ID: 1, LABEL: 'Service Notes Comments' },
  OUT_OF_TOLERANCE: { ID: 1, LABEL: 'Out Of Tolerance' },
  CHANGE_REQUEST_FORM: { ID: 2, LABEL: 'Change Request Form' },
  SERVICE_RECORD: { ID: 3, LABEL: 'Service Record' },
  SERVICE_CHECKLIST: { ID: 4, LABEL: 'Service Checklist' },
};

// Capital Purchase Report Column Constants
export const CAPITAL_PURCHASE_PRIORITY_COLUMNS = ['PO Number'];

export const CAPITAL_PURCHASE_COLUMN_LABELS = {
  'SAP Quantity': 'Qty per Purchase Item (SAP)',
  'ELM Quantity': 'Qty per Purchase Item (ELM)',
  EntityName: 'Entity Name',
  'PI Description': 'Purchase Item',
  EntityOwnerName: 'Entity Owner',
};

export const CAPITAL_PURCHASE_EXCLUDED_COLUMNS = ['Entity_DBID', 'PI_DBID'];

export const CAPITAL_PURCHASE_RIGHT_ALIGN_COLUMNS = [
  'SAP Quantity',
  'ELM Quantity',
];

export const CAPITAL_PURCHASE_DATE_COLUMNS = [
  'AssetInServiceDate',
  // Add other date column names as needed
];

export const CAPITAL_ASSET_FIELDS = {
  PO_NUMBER: 'PO Number',
  IO_NUMBER: 'IO Number',
  C_TAG: 'CTag',
};

export const CTAG_PATTERN = /^C\d{6}$/;

export const CTAG_FORMAT_MESSAGE =
  'CTag must start with "C" followed by 6 digits (e.g., C123456).';

export const SAP_NUMBER_FIELD = 'SAP Number';

export const SAP_NUMBER_PATTERN = /^\d{4}-\d{12}-\d{4}$/;

export const SAP_NUMBER_FORMAT_MESSAGE =
  'SAP Number must be in the format 0000-000000000000-0000 (4 digits - 12 digits - 4 digits).';

export const SHAREPOINT_LINK_PREFIX = 'https://nandps.sharepoint.com/';
